import React from 'react';
import { Plus } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';

const AddRateDialog = ({ open, onOpenChange, newRate, setNewRate, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle style={{ fontFamily: 'Manrope' }}>Add Billing Code</DialogTitle>
        <DialogDescription>Add a new HCPCS code to this contract</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>HCPCS Code *</Label>
            <Input
              value={newRate.hcpcs_code}
              onChange={(e) =>
                setNewRate((prev) => ({ ...prev, hcpcs_code: e.target.value.toUpperCase() }))
              }
              placeholder="e.g., T1019"
              data-testid="add-rate-code"
            />
          </div>
          <div className="space-y-2">
            <Label>Unit Type</Label>
            <Select
              value={newRate.unit_type}
              onValueChange={(v) => setNewRate((prev) => ({ ...prev, unit_type: v }))}
            >
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="15min">15 min</SelectItem>
                <SelectItem value="30min">30 min</SelectItem>
                <SelectItem value="60min">60 min</SelectItem>
                <SelectItem value="visit">Per Visit</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="space-y-2">
          <Label>Description *</Label>
          <Input
            value={newRate.description}
            onChange={(e) => setNewRate((prev) => ({ ...prev, description: e.target.value }))}
            placeholder="Service description"
            data-testid="add-rate-desc"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Unit Rate ($) *</Label>
            <Input
              type="number" step="0.01"
              value={newRate.unit_rate}
              onChange={(e) =>
                setNewRate((prev) => ({ ...prev, unit_rate: parseFloat(e.target.value) || 0 }))
              }
              data-testid="add-rate-unit"
            />
          </div>
          <div className="space-y-2">
            <Label>Base Rate ($)</Label>
            <Input
              type="number" step="0.01"
              value={newRate.base_rate}
              onChange={(e) =>
                setNewRate((prev) => ({ ...prev, base_rate: parseFloat(e.target.value) || 0 }))
              }
              data-testid="add-rate-base"
            />
          </div>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={onSave}
          className="bg-indigo-900 hover:bg-indigo-800"
          data-testid="save-add-rate-btn"
        >
          <Plus size={16} className="mr-2" /> Add Code
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default AddRateDialog;
